import { ICellRendererParams } from 'components/AgGrid/types'

import {
  Empty90DaysOrders,
  ErrorOverlay,
  FiltersEmptyResultOverlay,
  JoorPayDisabledOverlay,
  JoorPayEnabledOverlay,
  LoadingOverlay,
} from './components'

function EmptyPayOrdersOverlay(
  props: ICellRendererParams & EmptyPayOrdersOverlayProps,
) {
  const {
    isJoorPayEnabled,
    isBeingFiltered,
    isDataLoading,
    hasRequestErrors,
    isRequestingAllOrders,
    onReloadClick,
    onAllOrdersClick,
    onClearFiltersClick,
  } = props

  if (isDataLoading) {
    return <LoadingOverlay />
  }

  if (!isJoorPayEnabled) {
    return (
      <JoorPayDisabledOverlay
        onLinkClick={() => window.open(JOOR_PAY_URL, '_blank')}
      />
    )
  }

  if (hasRequestErrors) {
    return <ErrorOverlay onLinkClick={onReloadClick} />
  }

  if (isBeingFiltered) {
    return <FiltersEmptyResultOverlay onLinkClick={onClearFiltersClick} />
  }

  if (!isRequestingAllOrders) {
    return <Empty90DaysOrders />
  }

  return <JoorPayEnabledOverlay onLinkClick={onAllOrdersClick} />
}

type EmptyPayOrdersOverlayProps = {
  isJoorPayEnabled: boolean
  isBeingFiltered: boolean
  isDataLoading: boolean
  hasRequestErrors: boolean
  isRequestingAllOrders: boolean
  onAllOrdersClick: () => void
  onClearFiltersClick: () => void
  onReloadClick: () => void
}

export const EmptyPayOrdersOverlayTestIds = {
  OverlayIconOrder: 'empty-pay-orders-overlay-icon-order',
  OverlayIconSearch: 'empty-pay-orders-overlay-icon-search',
  OverlayIconError: 'empty-pay-orders-overlay-icon-error',
} as const

const JOOR_PAY_URL = 'https://www.joor.com/joor-pay'

export default EmptyPayOrdersOverlay
